export default __webpack_public_path__ + "static/media/icon-plugin2.c25438c2.svg";